import { Group, Modal, rem, Text } from "@mantine/core";
import { Dropzone } from "@mantine/dropzone";
import React, { useEffect, useState } from "react";
import { MdOutlineFileUpload } from "react-icons/md";
import { BiLoaderAlt } from "react-icons/bi";
import { connect } from "react-redux";
import { errorMessage, successMessage } from "../../utilities/notification";
import {
  previewBulkSubscription,
  runCsvCampaign,
  uploadBulkSubscription,
} from "../../stores/actions/campaign.actions.types";
import { TextAreaInput } from "../UI/FormField";
import EmailTemplateSelect from "../Common/EmailTemplateSelect";
import { Form, Formik } from "formik";
import { emailTemplateList } from "../../stores/actions/emailtemplate.actions.types";

const BulkEmailUpload = ({
  previewBulkSubscription,
  uploadBulkSubscription,
  type,
  emailTemplateList,
  runCsvCampaign,
  reload,
  setReload,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [previewList, setPreviewList] = useState([]);
  const [fileData, setFileData] = useState(null);
  const [showInputs, setShowInputs] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    if (showInputs) {
      emailTemplateList({
        data: { size: 10000 },
        callback: (res) => {
          if (res.success) {
            setTemplates(res?.data?.emailTemplates || []);
          }
        },
      });
    }
  }, [emailTemplateList, showInputs]);

  const handlePreview = async (files) => {
    setLoading(true);
    setFileData(files[0]);
    try {
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("type", type);
      previewBulkSubscription({
        data: formData,
        callback: (res) => {
          setPreviewList(res?.data?.subscriptions || []);
          setLoading(false);
        },
      });
    } catch (err) {
      setLoading(false);
      errorMessage("Failed to preview file!");
    }
  };

  const handleUpload = async () => {
    if (!fileData) return;
    setUploadLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", fileData);
      formData.append("type", type);

      uploadBulkSubscription({
        data: formData,
        callback: (res) => {
          setUploadLoading(false);
          successMessage("Subscription Added Successfully");
          setReload(!reload);
        },
      });
    } catch (err) {
      setUploadLoading(false);
      errorMessage("Failed to upload contacts!");
    }
  };

  const closeModal = () => {
    setOpenModal(false);
    setPreviewList([]);
    setFileData(null);
    // setReload(!reload);
  };

  const handleSubmit = (values) => {
    setSendLoading(true);
    const callback = (data) => {
      if (data.success) {
        setSendLoading(false);
        successMessage(
          `${type === "phone" ? "Phone" : "Email"} Added Successfully`
        );
      }
    };

    const request = { data: { type, previewList, ...values }, callback };
    runCsvCampaign(request);
  };

  return (
    <div>
      <button
        className='bg-red-600 px-3 py-1 text-white capitalize'
        onClick={() => setOpenModal(true)}
      >
        Bulk Upload {type}
      </button>

      <Modal
        size={"50%"}
        zIndex={999}
        opened={openModal}
        onClose={closeModal}
        title='Bulk Upload Emails/Phones'
      >
        {previewList.length > 0 ? (
          <div className='space-y-2'>
            <div className='max-h-64  overflow-y-auto border rounded p-2'>
              <div className='grid grid-cols-3 font-semibold border-b pb-1 px-2'>
                <span>Company</span>
                <span className='ml-6'>Name</span>
                <span className='ml-10'>
                  {type === "email" ? "Email" : "Phone"}
                </span>
                <span></span>
              </div>

              {previewList.map((contact, idx) => (
                <div
                  key={idx}
                  className='grid w-[600px]  text-sm grid-cols-3 px-2 py-1 border-b last:border-b-0'
                >
                  <span>
                    ({contact.row}) {contact.companyName}
                  </span>
                  <span>{contact.name}</span>
                  <span>
                    {type == "email" ? contact.email : contact?.phone}
                  </span>
                  <span></span>
                </div>
              ))}
            </div>

            {showInputs ? (
              <div>
                <Formik
                  initialValues={{
                    emailTemplateId: "",
                    smsText: "",
                  }}
                  onSubmit={handleSubmit}
                >
                  {({ errors, touched, setFieldValue, values }) => (
                    <Form className='space-y-4'>
                      {/* Dynamic Section based on type */}
                      {type === "email" ? (
                        <EmailTemplateSelect
                          templates={templates}
                          value={values.emailTemplateId}
                          setFieldValue={setFieldValue}
                        />
                      ) : (
                        <TextAreaInput
                          label='SMS Text'
                          name='smsText'
                          maxLength={150}
                          placeholder='Enter SMS message'
                          className='block w-full rounded-md border px-3 py-2'
                        />
                      )}
                      {/* Buttons */}
                      <div className='flex gap-2 justify-end mt-4'>
                        <button
                          type='submit'
                          disabled={sendLoading}
                          className='bg-primary w-full  px-4 py-2 rounded text-white flex items-center justify-center'
                        >
                          {sendLoading ? (
                            <BiLoaderAlt className='animate-spin m-auto' />
                          ) : (
                            "Send"
                          )}
                        </button>
                        <button
                          type='button'
                          onClick={() => setShowInputs(false)}
                          className='bg-gray-200 px-4 py-2 rounded text-gray-700 w-full'
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            ) : (
              <div className='flex items-center gap-10 py-6'>
                <button
                  className='bg-red-600 px-3 capitalize py-1 text-white w-full'
                  onClick={() => setShowInputs(true)}
                >
                  {`Send ${type} Now`}
                </button>
                <button
                  className='bg-red-600 px-3 py-1 text-white w-full'
                  disabled={uploadLoading}
                  onClick={handleUpload}
                >
                  {uploadLoading ? (
                    <BiLoaderAlt className='m-auto animate-spin text-2xl' />
                  ) : (
                    "Add To Subscription"
                  )}
                </button>
              </div>
            )}
          </div>
        ) : (
          <Dropzone
            loading={loading}
            onDrop={handlePreview}
            maxSize={5 * 1024 ** 2}
            onReject={() => errorMessage("Only CSV or XLSX files are allowed!")}
            accept={{
              "text/csv": [".csv"],
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                [".xlsx"],
              "application/vnd.ms-excel": [".xls"], // optional legacy Excel format
            }}
          >
            <Group
              justify='center'
              gap='xl'
              mih={220}
              style={{ pointerEvents: "none" }}
            >
              <Dropzone.Accept>
                <MdOutlineFileUpload
                  style={{
                    width: rem(52),
                    height: rem(52),
                    color: "var(--mantine-color-blue-6)",
                  }}
                  stroke={1.5}
                />
              </Dropzone.Accept>
              <Dropzone.Reject>
                <MdOutlineFileUpload
                  style={{
                    width: rem(52),
                    height: rem(52),
                    color: "var(--mantine-color-red-6)",
                  }}
                  stroke={1.5}
                />
              </Dropzone.Reject>
              <Dropzone.Idle>
                <MdOutlineFileUpload
                  style={{
                    width: rem(52),
                    height: rem(52),
                    color: "var(--mantine-color-dimmed)",
                  }}
                  stroke={1.5}
                />
              </Dropzone.Idle>

              <div>
                <Text size='xl' inline>
                  Drag CSV here or click to select emails/phones
                </Text>
              </div>
            </Group>
          </Dropzone>
        )}
      </Modal>
    </div>
  );
};

export default connect(null, {
  previewBulkSubscription,
  uploadBulkSubscription,
  emailTemplateList,
  runCsvCampaign,
})(BulkEmailUpload);
